export default __webpack_public_path__ + "static/media/timed.4ead42c0.png";